export const isoStandard = (number, isFixed) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: isFixed && 2,
    maximumFractionDigits: isFixed && 2,
    useGrouping: true,
  }).format(number);
};
